import React, { useContext, useState } from "react";
import Image from "components/image";
import Link from "helpers/link";
import { TELEPHONE_NUMBER } from "utils/constants";
import { CartContext } from "context/cart";
import Icon from "@root/_components/Icon/icon";
import MobileHeaderData from "./data";
import SearchByImage from "@root/components/header/search-by-image";

const MobileHeader = ({ data: { logo, links } }) => {
    const { cart: { items } } = useContext(CartContext);
    const [openedSidebar, setSidebar] = useState(false);

    return (
        <header className="header header--mobile">
            <nav className="header__container" aria-label="Main Menu">
                <div className="container">
                    <div className="header__controls">
                        <button 
                            type="button"
                            onClick={() => setSidebar((prevState) => !prevState)}
                            aria-label="hamburger-menu"
                            className="header__hamburger-btn"
                        >
                            <Icon icon="menu" color="#00334e" size={32} />
                        </button>
                        <Image image={logo} to="/" width={125} className="header__logo" />
                    </div>
                    <div className="header__actions">
                        {/*<SearchByImage />*/}
                        <Link to={TELEPHONE_NUMBER} aria-label="Call Us" className="header__actions--phone">
                            <Icon icon="phone-call" color="#00334e" size={24} />
                        </Link>
                        <Link to="/account" aria-label="Navigate to account page" className="header__actions--account">
                            <Icon icon="user" color="#00334e" size={24} />
                        </Link>
                        <Link to="/cart" aria-label="Navigate to cart page" className="header__actions--cart">
                            <Icon icon="shopping-bag" color="#00334e" size={24} />
                            {items?.length ? <div className="header__cart-badge" /> : <div className="header__cart-badge--hidden" />}
                        </Link>
                    </div>
                </div>
            </nav>
            <MobileHeaderData
                data={links}
                logo={logo}
                openedSidebar={openedSidebar}
                setSidebar={setSidebar}
            />
        </header>
    );
};

export default MobileHeader;
